import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Eye } from "lucide-react";
import { syncTenantContext } from "@/integrations/supabase/setTenantContext";

interface ImpersonationData {
  tenantId: string;
  tenantName: string;
  originalTenantId: string | null;
}

export function ImpersonationBanner() {
  const [data, setData] = useState<ImpersonationData | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const raw = sessionStorage.getItem("impersonation");
      if (raw) setData(JSON.parse(raw));
    } catch {}
  }, []);

  if (!data) return null;

  const handleEnd = async () => {
    sessionStorage.removeItem("impersonation");
    if (data.originalTenantId) {
      localStorage.setItem("currentTenantId", data.originalTenantId);
      await syncTenantContext(data.originalTenantId);
    }
    window.location.href = "/admin/tenants";
  };

  return (
    <div className="sticky top-0 z-50 flex items-center justify-center gap-3 bg-destructive px-4 py-2 text-destructive-foreground text-sm">
      <Eye className="h-4 w-4" />
      <span>
        Você está visualizando como <strong>{data.tenantName}</strong>
      </span>
      <Button
        size="sm"
        variant="secondary"
        className="h-7 text-xs"
        onClick={handleEnd}
      >
        <LogOut className="h-3 w-3 mr-1" />
        Encerrar
      </Button>
    </div>
  );
}
